import {CasinoLobby, CasinoSortedLobby, CasinoStudio, JackpotList, LaunchCasinoGameResponse} from "../http/protocol";
import {HttpService} from "../http/HttpService";


export class CasinoService {
    constructor(private http : HttpService) {}

    getCasinoGames() : Promise<CasinoLobby> {
        return this.http.get("/casino/lobby");
    }

    getSortedLobby() : Promise<CasinoSortedLobby> {
        return this.http.get("/casino/v2/lobby");
    }

    getGameLaunchUrl(gameId : string, currency : string, mobile?: boolean, language? : string) : Promise<LaunchCasinoGameResponse> {
        return this.http.get("/casino/launch/"+gameId+"/"+currency+"/" +  (mobile ? "true" : "false") + "/" + language);
    }

    getDemoGameLaunchUrl(gameId : string, language? : string, mobile?: boolean) : Promise<LaunchCasinoGameResponse>{
        return this.http.get("/casino/launch-demo/"+gameId+"/"+ language + "/" + (mobile ? "true" : "false"));
    }

    getJackpots() : Promise<JackpotList> {
        return this.http.get<JackpotList>("/casino/jackpots");
    }
}



